import React, { memo } from 'react';
import LicenceActivationContainer from '../../containers/LicenceActivationContainer';
import ResendActivationCodeFormContainer from '../../containers/ResendActivationCodeFormContainer';
import LicenceErrorContainer from '../../containers/LicenceErrorContainer';
import styles from './licence.module.scss';

export default memo(function Licence(props) {
    return (
        <>
            {
                props.licenceStatus === 200 &&
                <div className={styles.container}>
                    <LicenceActivationContainer />
                    <ResendActivationCodeFormContainer />
                </div>
            }
            {props.licenceStatus !== 200 && <LicenceErrorContainer />}
        </>
    );
});
